import { Separator } from '@components/ui/separator';

import type { AtomModel } from '@models/atom.model';

import type { TableEditorNumberColumnData } from '@stratumn/studio-shared';
import { NumberWidgetSettings } from '@widgets/number/number.widget.settings';

type Props = {
  atom: AtomModel<TableEditorNumberColumnData>;
};

export const NumberSettingsModal = ({ atom }: Props) => {
  return (
    <>
      {atom.data.isEditMode ? (
        // We use the number widget settings here
        // because editor and widget's settings are the same
        <NumberWidgetSettings
          atomId={atom.id}
          onOptionsChange={v =>
            (atom.data.editorOptions.editors.number.format.options = v)
          }
          options={atom.data.editorOptions.editors.number.format.options}
          settingsTitle="Number editor format settings"
        />
      ) : (
        <NumberWidgetSettings
          atomId={atom.id}
          onOptionsChange={v => (atom.data.cell.view.format.options = v)}
          options={atom.data.cell.view.format.options}
          settingsTitle="Number display format settings"
        />
      )}
      <Separator />
    </>
  );
};
